module.exports = __webpack_public_path__ + "static/media/how-it-works-step-4.5e940f47.jpg";